export function clearUndefined<T extends {}>(obj: T): Partial<T> {
  return Object.entries(obj).reduce<Partial<T>>(
    (cleaned, [key, value]) =>
      value !== undefined ? Object.assign(cleaned, { [key]: value }) : cleaned,
    {},
  );
}
